import LoaderWrapper from './LoaderWrapper';

export default LoaderWrapper;
